import React, { useState } from "react";
import useStyles from "components/User/CreateUser/CreateUserStyle";
import {
  TextField,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Button,
  useMediaQuery,
  OutlinedInput,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { FileCopy } from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import { useSelector } from "react-redux";
import "date-fns";

import { InviteType, UserRole, UserRoleText, USER_PROP } from "../constants";
import userActions from "components/User/actions";
import appActions from "components/app/actions";
import { Link } from "react-router-dom";
import { checkMultiEmailValid } from "../Validation";
import { AppRouteURI } from "router/RoleBasedAccess";

const InviteEmailLinkForm = () => {
  const classes = useStyles();
  const { inviteType, selectedRole, inviteLink } = useSelector(
    (state) => state.user
  );
  const { closeCreateDialog, sendInvite, generateInviteLink, setInviteLink } =
    userActions();
  const { setToastMessage } = appActions();
  const [selectedDate, setSelectedDate] = useState(null);
  const submitForm = (event) => {
    event.preventDefault();
    // Invite API
    if (inviteType === InviteType.EMAIL) {
      sendInvite(
        {
          role: invite[USER_PROP.ROLE],
          email: invite[USER_PROP.EMAIL],
          expiry_date: selectedDate && selectedDate.getTime(),
        },
        closeCreateDialog
      );
    }
  };
  const handleDateChange = (date) => {
    if (inviteType === InviteType.LINK) {
      setInviteLink("");
    }
    setSelectedDate(date);
  };

  const onCopyInvite = () => {
    const copyText = document.getElementById("inviteLinkInput");
    copyText.select();
    const maxRange = 200;
    copyText.setSelectionRange(0, maxRange);
    document.execCommand("copy");

    setToastMessage({ message: "Link Copied", type: "success" });
  };
  const [isFieldChecked, setFieldChecked] = useState(false);
  const [invite, setInvite] = useState({
    [USER_PROP.ROLE]: selectedRole,
    [USER_PROP.EMAIL]: "",
  });
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <div className={classes.content} onSubmit={submitForm}>
      <form noValidate>
        <Grid container direction="row" justify="space-between">
          <Grid item xs={12} sm={6}>
            <InputLabel size="small" className={classes.formControl}>
              Role
            </InputLabel>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
              className={classes.formControl}
            >
              <Select
                required
                onChange={(e) => {
                  if (inviteType === InviteType.LINK) {
                    setInviteLink("");
                  }
                  setInvite({
                    ...invite,
                    [USER_PROP.ROLE]: e.target.value,
                  });
                }}
                value={invite[USER_PROP.ROLE]}
              >
                {Object.keys(UserRole).map((x) => {
                  return (
                    <MenuItem value={UserRole[x]} key={x}>
                      {UserRoleText[x]}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={5}>
            <InputLabel size="small" className={classes.formControl}>
              Expiry Date
            </InputLabel>
            <MuiPickersUtilsProvider
              variant="outlined"
              className={classes.datepicker}
              utils={DateFnsUtils}
            >
              <KeyboardDatePicker
                variant="outlined"
                format="MM/dd/yyyy"
                margin="normal"
                value={selectedDate}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                minDate={new Date()}
                disablePast
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>

        {inviteType === InviteType.EMAIL && (
          <div>
            <InputLabel size="small" className={classes.formControl}>
              Email Address
            </InputLabel>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                variant="outlined"
                size="small"
                error={
                  isFieldChecked &&
                  !checkMultiEmailValid(invite[USER_PROP.EMAIL])
                }
                multiline
                rows={5}
                required
                fullWidth
                name="Email"
                placeholder="name@mrc.com, email@domain.com"
                helperText="Users will get an email that
                gives them access to the tool"
                autoComplete="Email"
                onClick={() => {
                  setFieldChecked(true);
                }}
                onChange={(e) =>
                  setInvite({
                    ...invite,
                    [USER_PROP.EMAIL]: e.target.value,
                  })
                }
                value={invite[USER_PROP.EMAIL]}
              />
            </FormControl>
          </div>
        )}
        {inviteType === InviteType.LINK && (
          <div>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              className={classes.formControl}
            >
              <Grid item>
                <InputLabel size="small">Invite Link</InputLabel>
              </Grid>
              <Grid item>
                <Button
                  size="small"
                  color="primary"
                  onClick={() =>
                    generateInviteLink({
                      role: invite[USER_PROP.ROLE],
                      expiry_date: selectedDate && selectedDate.getTime(),
                    })
                  }
                >
                  Generate
                </Button>
              </Grid>
            </Grid>
            <FormControl fullWidth size="small" className={classes.formControl}>
              <OutlinedInput
                id="inviteLinkInput"
                placeholder="https://svp.mrc/"
                variant="outlined"
                value={inviteLink}
                endAdornment={
                  <InputAdornment position="end" fontSize="small">
                    <IconButton
                      onClick={() => onCopyInvite()}
                      onMouseDown={(event) => {
                        event.preventDefault();
                      }}
                      edge="end"
                    >
                      <FileCopy />
                    </IconButton>
                  </InputAdornment>
                }
              />
              <FormHelperText>
                People can join CuRVE with a link. If you no longer need this
                link,{" "}
                <Link
                  to={AppRouteURI.HOME}
                  onClick={() => closeCreateDialog()}
                  color="inherit"
                >
                  deactivate
                </Link>{" "}
                it
              </FormHelperText>
            </FormControl>
          </div>
        )}
        {inviteType === InviteType.EMAIL && (
          <Grid container justify="flex-end">
            <Button
              fullWidth={!matches}
              type="submit"
              disabled={!checkMultiEmailValid(invite[USER_PROP.EMAIL])}
              variant="contained"
              color="primary"
              className={classes.action}
            >
              Send Invite
            </Button>
          </Grid>
        )}
      </form>
    </div>
  );
};

export default InviteEmailLinkForm;
